import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const d = heroData;

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-950 via-background-950/95 to-primary-950/60" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* 左侧文字区 */}
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-sm font-medium">{d.tagline}</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-4">
              {d.h1}
            </h1>

            <p className="text-lg md:text-xl text-primary-300 font-medium mb-6">
              {d.slogan}
            </p>

            <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              {d.description}
            </p>

            {/* 运营数据 */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {d.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            {/* CTA 按钮 */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={d.primaryCta.anchor}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-400 text-background-50 font-bold text-sm md:text-base transition-all duration-200 cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                {d.primaryCta.label}
              </a>
              <a
                href={d.secondaryCta.anchor}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 text-background-50 font-medium text-sm md:text-base transition-all duration-200 cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                {d.secondaryCta.label}
              </a>
            </div>
          </div>

          {/* 右侧主视觉 */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[350px] md:w-[360px] md:h-[480px] rounded-2xl overflow-hidden">
              <img
                src={d.heroImage}
                alt="每日黑料吃瓜网主视觉图 - 黑料爆料聚合平台"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
                  <span className="text-xs text-background-50 font-medium">实时更新中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}